export class tbl_objekt_flags {
    static readonly flag_Objekt_GefaesssperreOnStellen_herkoemmlich: number = (1 << 0);
    static readonly flag_Objekt_GefaesssperreOnStellen_Identcodesperre: number = (1 << 1);

    static readonly flag_Objekt_ObjektTyp_Halde: number = 101;
}